import {
  CustomButton,
  SearchBar,
  SwitchButton,
  searchDateFormat,
} from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { CustomModal, PopupModal } from "components/modals/ModalBox";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { userPlaceholder } from "assets/icons";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { DatePicker } from "common/InputForm";
import { toast } from "sonner";
import {
  brandDeleteApi,
  brandListApi,
  changeStatusBrandApi,
} from "services/brand";
import { AddProductBrandModel } from "./AddProductBrand";
import { EditProductBrandModel } from "./EditProductBrand";

const OnboardingBrandManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [addModal, setAddModal] = useState(false);
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const statusValue = searchParams.get("status") || "";
  const brandValue = searchParams.get("brand") || "";
  const [total, setTotal] = useState(null);
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  const [statusModal, setStatusModal] = useState(false);
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  let [inputData, setInputData] = useState({});
  const [editModal, setEditModal] = useState(false);
  const limit = +searchParams.get("limit") || 10;
  const [loader, onShow, onHide] = useFullPageLoader();
  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await brandDeleteApi(selected.id);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        setDeleteModal(false);
        brandListHandler();
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handleBrandStatus = (event) => {
    const value = event.target.value;
    searchParams.set("brand", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  // change student status
  const statusHandler = (teacherId, status) => {
    setSelected({
      ...selected,
      id: teacherId,
      status: status === "true" ? "false" : "true",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await changeStatusBrandApi(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        brandListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("page");
    searchParams.delete("brand");
    searchParams.delete("status");

    setSearch("");
    setSearchParams(searchParams);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  // brand list handler
  const brandListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    status = statusValue,
    brandType = brandValue,
    type="product"
  ) => {
    try {
      onShow();

      const res = await brandListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        status,
        brandType,
        type,
      });
      if (res?.data?.status === 200) {
        setTotal(res.data.data.total);
        setBrandList(res.data?.data?.brands);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "brandList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    brandListHandler();
  }, [
    searchParams,
    debouncedValue,
    fieldName,
    direaction,
    searchStartDate,
    searchEndDate,
  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  return (
    <>
      <div className="student_management">
      <div className="card top_card">
        <div className="dashboard_title has_child">
          <h3>Product Brand</h3>
          <CustomButton
            type="button"
            className="button mx-2"
            onClick={() => setAddModal(true)}
          >
            Add Brand
          </CustomButton>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search..."}
              onChange={(e) =>{ setSearch(e.target.value)
                searchParams.delete("page");
                setSearchParams(searchParams);

                }
              }              value={search}
            />

            <div className="d-flex align-items-center">
              <select
                className="input form-control"
                value={statusValue}
                onChange={handleStatus}
              >
                <option value={""}>Select Status</option>
                <option value="true">Active</option>
                <option value="false">In Active</option>
              </select>
           
              <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
            </div>
          </div>
          <div className="button_section justify-content-end">
            <div className="d-flex"></div>
          </div>
        </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">S.No. </th>

                    <th className="nowrap cursor-pointer" onClick={() => handleSort("name")}>
                      Brand name
                      <span className="shorting">
                      {fieldName === "name"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                        </span>
                    </th>
                
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("orderNumber")}
                    >
                      Order Number
                      <span className="shorting">
                      {fieldName === "orderNumber"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                        </span>
                    </th>
                    <th className="text-center">Status</th>

                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {brandList && brandList.length > 0 ? (
                      brandList?.map((data, index) => {
                        return (
                          <tr key={++index}>
                            <td className="text-center">{index + 1}</td>   
                            <td className="nowrap">{data?.name}</td>
                            <td>{data?.orderNumber}</td>
                            <td>  
                                <Link
                                  to=""
                                  onClick={(e) => {
                                    e.preventDefault();
                                    statusHandler(
                                      data._id,
                                      data?.status.toString()
                                    )
                                  }
                                  }
                                >
                                  <SwitchButton
                                    status={data?.status.toString()}
                                  />
                                  
                                </Link></td>

                            <td>
                              {" "}
                              <div className="icon_wrap">
                              <Link
                                  className="icon_button"
                                  onClick={() => {
                                    setEditModal(true);
                                    setInputData(data);
                                  }}
                                >
                                  <FaRegEdit />
                                </Link>
                                <Link
                                  to=""
                                  className="icon_button"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    deleteHandler(data?._id);
                                  }}
                                >
                                  <FaRegTrashAlt />
                                </Link>
                            
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <NotFound
                        cols={7}
                        msg={"Brand data not found"}
                        onHide={onHide}
                      />
                    )}
             
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <AddProductBrandModel
        setAddModal={setAddModal}
        addModal={addModal}
        brandListHandler={brandListHandler}
      />
      <EditProductBrandModel
        setEditModal={setEditModal}
        editModal={editModal}
        brandListHandler={brandListHandler}
        inputData={inputData}
        setInputData={setInputData}
      />
      {/* Delete Brand Modal */}      
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Brand?"
        title="Delete Brand"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Brand?"
        title="Change Status"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />
      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>
    </>
  );
};
export default OnboardingBrandManagement;
